// extracted by mini-css-extract-plugin
export default {"ActivityIcon":"ActivityIcon_ActivityIcon__djf2M"};